(() => {
  'use strict';
  const levels = [1, 2, 4, 6, 10];
  const discountCents = [0, 1190, 1785, 2380, 2975];
  const allowed = new Set(['1100500', '1200500']);
  const locale = document.documentElement.lang || 'de-DE';
  const currency = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const money = cents => currency.format(Number(cents || 0) / 100);
  const amount = value => Math.max(1, Math.floor(Number(value) || 1));
  const writeText = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
    function init(root) {
    if (root.dataset.mseLiquidInitialized === '1') return;
    const sku = root.dataset.productSku || '';
    const form = root.closest('form');
    const actual = form?.querySelector('[name="quantity"]');
    const displayed = root.querySelector('[data-mse-liquid-qty]');
    const base = Number(root.dataset.baseGross);
    const vat = Number(root.dataset.vatDivisor);
    if (!allowed.has(sku) || !form || !actual || !displayed) return;
    if (!Number.isSafeInteger(base) || base < 2837 || !Number.isFinite(vat) || vat < 100 || vat > 130) return;
    root.dataset.mseLiquidInitialized = '1';
    form.classList.add('mse-file-tiers--active');
    let alreadyInCart = 0;
    let cartGross = 0;
    const netFromGross = cents => Math.round(cents * 100 / vat);
    const get = () => amount(actual.value);
    const tierIndex = quantity => {
      let index = 0;
      for (let i = 0; i < levels.length; i++) {
        if (quantity >= levels[i]) index = i;
      }
      return index;
    };
    levels.forEach((quantity, index) => {
      const gross = base - discountCents[index];
      const elNet = root.querySelector('[data-tier-net="' + quantity + '"]');
      const elGross = root.querySelector('[data-tier-gross="' + quantity + '"]');
      writeText(elNet, money(netFromGross(gross)));
      writeText(elGross, '(' + money(gross) + ')');
    });
    function render() {
      const ownQty = get();
      const combined = ownQty + alreadyInCart;
      const index = tierIndex(combined);
      const grossUnit = base - discountCents[index];
      const totalGross = grossUnit * ownQty;
      const priceBlock = root.closest('.product-info')?.querySelector('.product-price');
      writeText(priceBlock?.querySelector('.price__current > .js-value .dualPrice'), money(grossUnit));
      writeText(priceBlock?.querySelector('.price-tax-info .dualPrice'), money(netFromGross(grossUnit)));
      if (document.activeElement !== displayed) displayed.value = String(ownQty);
      root.querySelectorAll('[data-tier-qty]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.tierQty) === levels[index]));
      });
      writeText(root.querySelector('[data-mse-liquid-unit-net]'), money(netFromGross(grossUnit)));
      writeText(root.querySelector('[data-mse-liquid-total-net]'), money(netFromGross(totalGross)));
      writeText(root.querySelector('[data-mse-liquid-total-gross]'), money(totalGross));
      const cartSummary = root.querySelector('[data-mse-liquid-cart-summary]');
      if (cartSummary) cartSummary.hidden = alreadyInCart === 0;
      writeText(root.querySelector('[data-mse-liquid-cart-count]'), String(alreadyInCart));
      writeText(root.querySelector('[data-mse-liquid-cart-net]'), money(netFromGross(cartGross)));
      writeText(root.querySelector('[data-mse-liquid-cart-gross]'), money(cartGross));
      const next = levels.find(tier => tier > combined);
      const unitLabel = root.dataset.unitMany || 'Flaschen';
      const nextMessage = next
        ? 'Noch ' + (next - combined) + ' ' + unitLabel + ' bis zur nächsten Preisstufe.'
        : 'Beste Preisstufe erreicht.';
      writeText(root.querySelector('[data-mse-liquid-next]'), nextMessage);
      const cartNote = root.querySelector('[data-mse-liquid-cart-note]');
      if (cartNote) {
        cartNote.hidden = alreadyInCart === 0;
        if (alreadyInCart) writeText(cartNote, alreadyInCart + ' ' + unitLabel + ' Magic Blue/Fast im Warenkorb berücksichtigt.');
      }
    }
    function set(value) {
      let quantity = amount(value);
      const max = Number(actual.max);
      if (Number.isFinite(max) && max > 0) quantity = Math.min(max, quantity);
      actual.value = String(quantity);
      displayed.value = String(quantity);
      actual.dispatchEvent(new Event('input', { bubbles: true }));
      actual.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    }
    root.querySelectorAll('[data-tier-qty]').forEach(button => {
      button.addEventListener('click', () => {
        const target = Number(button.dataset.tierQty);
        set(target);
      });
    });
    root.querySelector('[data-mse-liquid-minus]').addEventListener('click', () => set(get() - 1));
    root.querySelector('[data-mse-liquid-plus]').addEventListener('click', () => set(get() + 1));
    displayed.addEventListener('input', () => {
      if (Number(displayed.value) >= 1) set(displayed.value);
    });
    displayed.addEventListener('change', () => set(displayed.value));
    actual.addEventListener('input', render);
    actual.addEventListener('change', render);
    async function refreshCart() {
      try {
        const prefix = window.Shopify?.routes?.root || '/';
        const res = await fetch(prefix + 'cart.js', {headers: {Accept: 'application/json'}, credentials: 'same-origin', cache: 'no-store'});
        if (!res.ok) return;
        const cart = await res.json();
        const liquidLines = (cart.items || []).filter(line => allowed.has(String(line.sku || '').trim()));
        cartGross = liquidLines.reduce((sum, line) => sum + Math.max(0, Number(line.final_line_price) || 0), 0);
        alreadyInCart = liquidLines.reduce((sum, line) => {
          const itemSku = String(line.sku || '').trim();
          return sum + (allowed.has(itemSku) ? Math.max(0, Number.parseInt(line.quantity, 10) || 0) : 0);
        }, 0);
        render();
      } catch (error) {
        render();
      }
    }
    render();
    refreshCart();
    window.addEventListener('pageshow', refreshCart);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refreshCart();
    });
    document.addEventListener('mse:cart:item-added', () => {
      set(1);
      refreshCart();
    });
    document.addEventListener('on:line-item:change', refreshCart);
    document.addEventListener('on:cart:change', refreshCart);
    document.addEventListener('cart:updated', refreshCart);
  }
  const boot = () => document.querySelectorAll('[data-mse-liquid-tiers]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();